//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavMoreHoriz(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 14.25C13.2426 14.25 14.25 13.2426 14.25 12C14.25 10.7574 13.2426 9.75 12 9.75C10.7574 9.75 9.75 10.7574 9.75 12C9.75 13.2426 10.7574 14.25 12 14.25Z" fill="currentColor" /><path d="M5 14.25C6.24264 14.25 7.25 13.2426 7.25 12C7.25 10.7574 6.24264 9.75 5 9.75C3.75736 9.75 2.75 10.7574 2.75 12C2.75 13.2426 3.75736 14.25 5 14.25Z" fill="currentColor" /><path d="M19 14.25C20.2426 14.25 21.25 13.2426 21.25 12C21.25 10.7574 20.2426 9.75 19 9.75C17.7574 9.75 16.75 10.7574 16.75 12C16.75 13.2426 17.7574 14.25 19 14.25Z" fill="currentColor" /></svg>;
}
export default IconNavMoreHoriz;